/**
 * The ad parameters a sign-up address can carry - C-132 build item 1.
 *
 * The website (C-131) puts these on its links to `/sign-up`. The page reads
 * them once, from its own address, and sends them with the form. **The server
 * is the authority**: it keeps the known names within their caps and drops
 * anything else, quietly, so nothing here can make a sign-up fail. No cookie,
 * no storage, no script: they live in the address and in the one request.
 */
export const ATTRIBUTION_PARAMS = [
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export type Attribution = Partial<Record<(typeof ATTRIBUTION_PARAMS)[number], string>>;

/** The six values present on `search`, or null when there are none. */
export function attributionFrom(search: string): Attribution | null {
  const params = new URLSearchParams(search);
  const found: Attribution = {};
  for (const name of ATTRIBUTION_PARAMS) {
    const value = params.get(name)?.trim();
    if (value) found[name] = value;
  }
  return Object.keys(found).length > 0 ? found : null;
}
